"use client"
import Link from "next/link"
import Image from "next/image"
import { useEffect, useState } from "react"
import { useFavourites } from "@/lib/hooks/useFavourites"

export default function FavouritesPage() {
  const { favs, remove } = useFavourites()
  const [listings, setListings] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (favs.length === 0) { setLoading(false); setListings([]); return }
    setLoading(true)
    fetch("/api/listings?ids=" + favs.join(","))
      .then(r => r.json())
      .then(d => { setListings(d.data ?? []); setLoading(false) })
      .catch(() => setLoading(false))
  }, [favs.join(",")])

  function removeFav(id: string) {
    remove(id)
    setListings(prev => prev.filter(l => l.id !== id))
  }

  return (
    <div style={{ background: "var(--cream)", minHeight: "100vh" }}>
      <div style={{ background: "var(--navy)", padding: "48px 24px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>
          <h1 style={{ fontFamily: "Fraunces, serif", fontSize: 40, fontWeight: 700, color: "var(--cream)", marginBottom: 8 }}>Saved <em style={{ color: "var(--gold)" }}>properties</em>.</h1>
          <p style={{ color: "rgba(253,251,247,0.7)", fontSize: 15 }}>{listings.length} saved {listings.length === 1 ? "property" : "properties"}</p>
        </div>
      </div>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "40px 24px" }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: 80, color: "var(--muted)" }}>Loading...</div>
        ) : listings.length === 0 ? (
          <div style={{ textAlign: "center", padding: 80 }}>
            <div style={{ fontSize: 56, marginBottom: 20, color: "var(--red-text)" }}>♡</div>
            <h2 style={{ fontFamily: "Fraunces, serif", fontSize: 28, color: "var(--navy)", marginBottom: 8 }}>No saved properties yet</h2>
            <p style={{ color: "var(--muted)", marginBottom: 32 }}>Heart any listing to save it here.</p>
            <Link href="/listings" style={{ padding: "12px 24px", background: "var(--navy)", color: "var(--cream)", borderRadius: 10, textDecoration: "none", fontWeight: 700 }}>Browse listings</Link>
          </div>
        ) : (
          <div className="listings-grid">
            {listings.map(l => (
              <div key={l.id} style={{ position: "relative" }}>
                <button onClick={() => removeFav(l.id)} style={{ position: "absolute", top: 12, right: 12, zIndex: 10, background: "rgba(196,68,68,0.9)", border: "none", color: "white", borderRadius: "50%", width: 28, height: 28, cursor: "pointer", fontSize: 14 }}>×</button>
                <Link href={"/listings/" + l.id} className="listing-card">
                  <div className="listing-img" style={{ background: "linear-gradient(135deg,#3a4f7a,#1B2D54)" }}>
                    {l.photos?.[0] && <Image src={l.photos[0].url} alt={l.title} fill style={{ objectFit: "contain", backgroundColor: "var(--cream-warm)" }} />}
                    <span className="listing-tag">{l.priceType === "SALE" ? "FOR SALE" : "FOR RENT"}</span>
                  </div>
                  <div className="listing-body">
                    <div className="listing-price">${l.price?.toLocaleString()}</div>
                    <div className="listing-title">{l.title}</div>
                    <div className="listing-loc">{l.suburb}, {l.city}</div>
                    <div className="listing-meta">
                      {l.beds > 0 && <span>{l.beds} bed</span>}
                      {l.baths > 0 && <span>{l.baths} bath</span>}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
